import React from 'react'
import { FinanceWithdrawalAccountBlacklistQuery, PaginationReq } from '@golden/gdk-admin'
import Box from '@material-ui/core/Box'
import Paper from '@material-ui/core/Paper'
import FinanceWithdrawalAccountBlacklistTable from '../../../components/admin/finance/FinanceWithdrawalAccountBlacklistTable'
import FinanceWithdrawalAccountBlacklistForm from '../../../components/admin/finance/FinanceWithdrawalAccountBlacklistForm'
import { SearchToRequestFunc } from '../../../utils/default/ComplexFlowHook'
import {
  pipe,
  parseInt,
  acceptUndefined,
  guaranteeBetween
} from '../../../utils/default/FormHelper'
import { isUndefined, omitBy } from '@golden/utils'

export type Request = FinanceWithdrawalAccountBlacklistQuery & PaginationReq

export const searchToRequest: SearchToRequestFunc<Request> = (search) => {
  const converted = {
    ...search,
    start_at: acceptUndefined(search.start_at, parseInt),
    end_at: acceptUndefined(search.end_at, parseInt),
    page: acceptUndefined(
      search.page,
      pipe(
        parseInt,
        (value) => guaranteeBetween(value, 1, Number.MAX_SAFE_INTEGER)
      )
    ) || 1
  }
  if (converted.start_at && converted.end_at && converted.end_at < converted.start_at) {
    throw new Error('The end time can\'t exceed the start time')
  }
  return omitBy(converted, isUndefined) as Request
}

const FinanceWithdrawalAccountBlacklistPage: React.FC = () => {
  return (
    <Box paddingY={6}>
      <Box paddingX={6}>
        <Paper>
          <FinanceWithdrawalAccountBlacklistForm />
        </Paper>
      </Box>
      <Box paddingTop={2}>
        <FinanceWithdrawalAccountBlacklistTable />
      </Box>
    </Box>
  )
}

export default React.memo(FinanceWithdrawalAccountBlacklistPage)
